import { snowplowEvent } from 'Utilities/analytics';
import { type CTA_CLICK_EVENT_PAYLOAD, GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

import { type IncodeStepProps } from './IncodeSDKHelpers';

const CONTEXT_NAME = 'incode_sdk';

const contextEntity: {
  data?: Omit<IncodeStepProps['incodeSession'], 'token'>;
  schema: string;
} = {
  schema: 'iglu:uk.co.motorway/incode_context/jsonschema/1-0-0',
};

export const INCODE_ANALYTICS = Object.freeze({
  API_TRIGGERED: GENERIC_ANALYTICS_EVENTS.API_TRIGGERED,
  INCODE_ADD_CONTEXT: (payload: NonNullable<IncodeStepProps['incodeSession']>) => {
    const { token, ...data } = payload;

    contextEntity.data = data;

    window.snowplow?.('addGlobalContexts', [contextEntity]);
  },
  INCODE_CTA_CLICK: (payload: Pick<CTA_CLICK_EVENT_PAYLOAD, 'button_label' | 'name'>) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    category: CONTEXT_NAME,
    url: globalThis.location.pathname,
    ...payload,
  } satisfies CTA_CLICK_EVENT_PAYLOAD),
  INCODE_REMOVE_CONTEXT: () => {
    window.snowplow?.('removeGlobalContexts', [contextEntity]);
  },
  INCODE_SDK_LOADED: (data: { loadEventEnd: number; name: string }) => snowplowEvent({
    data,
    schema: 'page_timing',
    version: '1-1-0',
  }),
  INCODE_SECTION_LOADED: (name: string) => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: CONTEXT_NAME,
    name,
  }),
});
